function strToDisplayName(str) {
    switch (str.toLowerCase()) {
        case 'ceo':
          return "CEO"
        case 'cio/cdo':
          return "CIO/CDO"
        case 'mysql':
            return "MySQL"
        default:
            return str.toLowerCase().split(' ').map(function(word) {
                return (word.charAt(0).toUpperCase() + word.slice(1));
              }).join(' ');
    }
}

function parseJSON(str){
    return str.replace(/\s*(,|^|$)\s*/g, "$1").split(',')
}

function htmlParser(html) {
    return html.replace(/&#8211;/g, "-").replace(/&#8216;/g, "'").replace(/&#8217;/g, "'").replace(/&#038;/g, "&").replace(/&#038;/g, "&").replace(/&#8220;/g,"\"").replace(/&#8221;/g,"\"");
};

export {
    strToDisplayName,
    parseJSON,
    htmlParser
}      
